import styled from 'styled-components';
import { Label } from 'reactstrap';

export default styled(Label)`
  width: 100%;
  position: relative;
`;
